import React from 'react';
import {
	Page,
	Text,
	View,
	Document,
	StyleSheet,
	Image,
} from '@react-pdf/renderer';
import moment from 'moment';

import { color } from '~/assets/styles/colors';

import Lucree from '~/assets/img/logo-lucree-horizontal.png';

// Create styles
const styles = StyleSheet.create({
	page: {
		flexDirection: 'row',
		backgroundColor: '#FFF',
	},
	image: {
		width: 130,
		height: 50,
		marginBottom: 10,
	},
	section: {
		margin: 10,
		padding: 10,
		flexGrow: 1,
		fontSize: 10,
	},
	text: {
		marginBottom: 5,
	},
	title: {
		backgroundColor: color.yellow,
		fontSize: 14,
		padding: 5,
		textTransform: 'uppercase',
	},
	pageNumber: {
		position: 'absolute',
		fontSize: 12,
		bottom: 30,
		left: 0,
		right: 0,
		textAlign: 'center',
		color: 'grey',
	},
	titleDetail: {
		backgroundColor: color.primary,
		width: '100%',
		alignItems: 'center',
		padding: 8,
	},
	titleDetailText: {
		color: color.white,
	},
	detailList: {
		border: '1px solid #dddddd',
		alignItems: 'center',
		width: '100%',
		padding: 8,
	},
});

// Create Document Component
export function MyDocument({ anoGerado, loja, totais, listagem }) {
	return (
		<Document>
			<Page wrap size="A4" style={styles.page}>
				<View style={styles.section}>
					<Image style={styles.image} src={Lucree} />
					<Text style={styles.text}>Prezado(a) Cliente,</Text>
					<Text style={styles.text}>
						O documento que você está recebendo é um informe para o
						preenchimento de sua DIRF (Declaração do Imposto de
						Renda Retido na Fonte) anual.
					</Text>
					<Text style={styles.text}>
						Conforme o disposto no artigo 224, inciso III e XVII, da
						Instrução Normativa nº 888, de 19 de novembro de 2008,
						da Receita Federal do Brasil (publicado no D.O.U. de
						10.12.2008), os rendimentos e o respectivo Imposto de
						Renda retido na fonte devem ser informados na DIRF da
						pessoa jurídica que tenha pago a outras pessoas
						jurídicas importâncias a título de comissões e
						corretagens, relativas à administração de cartões de
						crédito em geral.
					</Text>

					<Text style={styles.text}>
						Em caso de dúvida, entre em contato com a nossa Central
						de Atendimento.
					</Text>

					<Text style={styles.text}>Atenciosamente,</Text>

					<Text style={styles.text}>
						Lucree Soluções Inteligentes S.A.
					</Text>

					<View style={styles.section}>
						<Text style={styles.title}>
							{`DIRF ANUAL – CALENDÁRIO ${anoGerado}`}
						</Text>
						<View>
							{loja && loja.nome !== '' ? (
								<View style={{ marginLeft: 0, marginRight: 0 }}>
									<View style={{ paddingTop: 0 }}>
										<Text
											style={{
												backgroundColor: color.primary,
												color: color.white,
												padding: 5,
											}}>
											<strong>Rendimento</strong>
										</Text>
										<Text
											style={{
												marginTop: 10,
												marginLeft: 10,
											}}>
											<b style={{ marginRight: '2px' }}>
												Descrição:
											</b>
											Administração de cartão de crédito
											ou débito e congêneres.
										</Text>
										<Text
											style={{
												marginTop: 5,
												marginLeft: 10,
											}}>
											<b style={{ marginRight: '2px' }}>
												Código de retenção:
											</b>
											8045-Comissões e corretagens pagas à
											pessoa jurídica.
										</Text>
										<Text
											style={{
												marginTop: 5,
												marginLeft: 10,
											}}>
											<b style={{ marginRight: '2px' }}>
												Referência:
											</b>
											{anoGerado}
										</Text>
									</View>

									<View style={{ marginTop: 10 }}>
										<Text
											style={{
												backgroundColor: color.primary,
												color: color.white,
												padding: 5,
											}}>
											<strong>Estabelecimento</strong>
										</Text>
										<Text
											style={{
												marginTop: 5,
												marginLeft: 10,
											}}>
											<strong>Razão social: </strong>
											{loja.nome}
										</Text>

										<Text
											style={{
												marginTop: 5,
												marginLeft: 10,
											}}>
											<strong>CNPJ: </strong>
											{loja.cnpj}
										</Text>
									</View>
								</View>
							) : (
								<div className="d-flex justify-content-center" />
							)}
						</View>

						<Text
							style={{
								backgroundColor: color.yellow,
								marginBottom: 0,
								marginTop: 20,
								padding: 5,
							}}
							className="py-2">
							<strong>TOTAIS</strong>
						</Text>
						<div>
							{totais &&
								totais.rendimentos !== 'R$' &&
								totais.recebido !== 'R$' && (
									<View
										style={{
											marginLeft: 0,
											marginRight: 0,
										}}>
										<Text
											style={{
												backgroundColor: color.primary,
												color: color.white,
												padding: 5,
											}}>
											<strong>Rendimento</strong>
										</Text>
										<Text
											style={{
												marginTop: 5,
												marginBottom: 10,
												marginLeft: 10,
											}}>
											{totais.rendimentos}
										</Text>

										<Text
											style={{
												backgroundColor: color.primary,
												color: color.white,
												padding: 5,
											}}>
											<strong>IRRF Retido</strong>
										</Text>
										<Text
											style={{
												marginTop: 5,
												marginBottom: 10,
												marginLeft: 10,
											}}>
											{totais.retido}
										</Text>
									</View>
								)}
						</div>

						<View break>
							<Text
								style={{
									backgroundColor: color.yellow,
									marginBottom: 0,
									marginTop: 20,
									padding: 5,
								}}
								className="py-2">
								<strong>DETALHES RENDIMENTOS</strong>
							</Text>
							{listagem && listagem.lista[0] ? (
								<View>
									<View style={{ flexDirection: 'row' }}>
										<View style={styles.titleDetail}>
											<Text
												style={styles.titleDetailText}>
												Mês
											</Text>
										</View>
										<View style={styles.titleDetail}>
											<Text
												style={styles.titleDetailText}>
												Num. NF
											</Text>
										</View>
										<View style={styles.titleDetail}>
											<Text
												style={styles.titleDetailText}>
												Rendimentos
											</Text>
										</View>
										<View style={styles.titleDetail}>
											<Text
												style={styles.titleDetailText}>
												IRRF Retido
											</Text>
										</View>
									</View>

									{listagem &&
										listagem.lista.map((item) => (
											<View
												key={item.num_nf}
												style={{
													flexDirection: 'row',
												}}>
												<View style={styles.detailList}>
													<Text>
														{moment(
															item.data_fato_gerado,
															'YYYY-MM-DD'
														)
															.format('MMMM')
															.toUpperCase()}
													</Text>
												</View>
												<View style={styles.detailList}>
													<Text>{item.num_nf}</Text>
												</View>
												<View style={styles.detailList}>
													<Text>
														{item.rendimentos.toLocaleString(
															'pt-br',
															{
																style: 'currency',
																currency: 'BRL',
															}
														)}
													</Text>
												</View>
												<View style={styles.detailList}>
													<Text>
														{item.retido.toLocaleString(
															'pt-br',
															{
																style: 'currency',
																currency: 'BRL',
															}
														)}
													</Text>
												</View>
											</View>
										))}
								</View>
							) : (
								<div />
							)}
						</View>
					</View>
				</View>
				<Text
					style={styles.pageNumber}
					render={({ pageNumber, totalPages }) =>
						`${pageNumber} / ${totalPages}`
					}
					fixed
				/>
			</Page>
		</Document>
	);
}
